export const requireMapboxAccessToken = (platform: 'native' | 'web'): string => {
    const variableName =
        platform === 'web'
            ? 'EXPO_PUBLIC_MAPBOX_WEB_ACCESS_TOKEN'
            : 'EXPO_PUBLIC_MAPBOX_NATIVE_ACCESS_TOKEN'
    const token =
        platform === 'web'
            ? process.env.EXPO_PUBLIC_MAPBOX_WEB_ACCESS_TOKEN
            : process.env.EXPO_PUBLIC_MAPBOX_NATIVE_ACCESS_TOKEN

    if (!token) throw new Error(`Missing ${variableName}`)

    return token
}
